// Import styles
import { ChannelsPlaceholders, ChannelPlaceholder } from '../styles/packet';
import { ChannelsList, ChannelsListItem, MoreChannelsButton } from './styles';

// Import types
import type { PacketChannel } from 'types/api/products/packet/products';

// Import components
import { ChannelImage } from 'components/elements/atoms/ChannelImage';

type Props = {
	channels: PacketChannel[];
	openModal: VoidFunction;
};

export const MainPacketChannels = ({ channels, openModal }: Props) => {
	if (!channels.length) {
		return (
			<ChannelsPlaceholders>
				{Array.from({ length: 6 }).map((el, i) => (
					<ChannelPlaceholder key={i} />
				))}
			</ChannelsPlaceholders>
		);
	}

	const slice = channels.slice(0, 5);

	const rest = channels.length - slice.length;

	return (
		<ChannelsList>
			{slice.map(({ uuid, title, images }) => (
				<ChannelsListItem key={uuid}>
					<ChannelImage images={images} title={title} ratio='3/1.9' /> 
				</ChannelsListItem>
			))}

			{rest > 0 && (
				<ChannelsListItem>
					<MoreChannelsButton onClick={openModal}>+{rest}</MoreChannelsButton>
				</ChannelsListItem>
			)}
		</ChannelsList>
	);
};
